export enum JourneySessionStorageKeys {
    isJourneySelected = 'isJourneySelected',
    ssrNewQuantitySet = "ssrNewQuantitySet",
    journeySameOptionsForAllPassengers = "journeySameOptionsForAllPassengers",
}